<div
  class="controls"
  [class.no-leave]="!isLeaveAvailable"
  [class.no-center]="!isCenterControlVisible"
  [class.no-share]="this.user.isCustomer"
  [class.size-md]="isSizeMedium"
  [class.size-lg]="isSizeLarge"
>
  <!-- [class.controls-viwport-xs]="isMobileSize()" -->
  <div class="share-mock"></div>
  <div class="center-controls fx-row fx-align-start" #centerControls>
    @if (isAudioDeviceAvailable) {
    <div class="control" [class.control-disabled]="isMicDisabled()">
      <button
        [attr.aria-label]="
          (isMutedMic ? 'Turn on microphone' : 'Turn off microphone')
            | translate
        "
        aria-haspopup="menu"
        aria-controls="mic-options-menu"
        class="mic-button room-control-min-size"
        #btnMicRef
        avButton
        ofType="icon"
        [color]="isMutedMic ? 'basic' : 'primary'"
        [size]="size"
        [raised]="true"
        id="btn-mute-mic"
        (click)="toggleMute(kindAudio)"
        (keydown)="focus($event, kindAudio)"
        [attr.data-tid]="
          isMutedMic ? 'stream-controls/mic-unmute' : 'stream-controls/mic-mute'
        "
      >
        @if (isMutedMic) {
        <av-icon name="mic-mute" mode="dark"></av-icon>
        } @if (!isMutedMic) {
        <av-icon name="mic"></av-icon>
        }
        <div class="volume-wrap">
          <div #volumeElem class="volume"></div>
        </div>
      </button>
      <!-- <button
        *ngIf="isControlOptionsToggleFocus() === kindAudio"
        (click)="controlOptionsToggle(kindAudio)"
        class="control-options-toggle"
        avButton
        size="xxs"
        ofType="icon"
        color="primary"
        >
        <av-icon name="chevron-right" size="sm"></av-icon>
      </button> -->
      @if (isAudioDeviceMissing || isAudioDevicePermissionMissing) {
      <av-tooltip
        class="control-error-tooltip"
        [message]="
          isAudioDeviceMissing ? 'No devices available' : 'Permission required'
        "
      >
        <div class="control-error">!</div>
      </av-tooltip>
      }
      <!-- [class.control-options-visible]="isControlOptionsVisible() === kindAudio" -->
      <av-card
        id="mic-options-menu"
        [class.hidden]="isMobile || isOnHold()"
        arrow="bottom"
        [backdrop]="true"
        [menu]="true"
        vAlign="top"
        [popup]="true"
        hAlign="center"
        class="control-options-on-hover"
        type="control-options"
      >
        <av-card-body size="xs" type="container">
          <av-menu>
            <av-menu-item icon="mic" [arrow]="true" [disabled]="isMutedMic">
              {{ activeAudioDevice.label }}
              <av-card sub-menu [backdrop]="false">
                <av-card-body size="xs">
                  <av-menu>
                    @for (device of audioDevices; track device.deviceId) {
                    <av-menu-item
                      type="radio"
                      (select)="changeDevice(device)"
                      [checked]="device.deviceId === activeAudioDevice.deviceId"
                      data-tid="stream-controls/change-mic"
                    >
                      <span>{{ device.label }}</span>
                    </av-menu-item>
                    }
                  </av-menu>
                </av-card-body>
              </av-card>
            </av-menu-item>
            @if (isSpeakerAvailable) {
            <av-menu-item type="separator"></av-menu-item>
            <av-menu-item icon="speaker" [arrow]="true">
              {{ activeSpeakerDevice.label }}
              <av-card sub-menu [backdrop]="false">
                <av-card-body size="xs">
                  <av-menu>
                    @for (device of speakerDevices; track device.deviceId) {
                    <av-menu-item
                      type="radio"
                      (select)="changeDevice(device)"
                      [checked]="
                        device.deviceId === activeSpeakerDevice.deviceId
                      "
                      data-tid="stream-controls/change-speaker"
                    >
                      <span>{{ device.label }}</span>
                    </av-menu-item>
                    }
                  </av-menu>
                </av-card-body>
              </av-card>
            </av-menu-item>
            } @if (isCaptionAvailable) {
            <div>
              <app-captions-control
                [conferenceId]="conferenceId"
                [istream]="istream"
                [stream]="localStream"
              >
              </app-captions-control>
            </div>
            } @if (isNoiseSuppressionAvailable) {
            <av-menu-item type="separator"></av-menu-item>
            <av-menu-item
              icon="mic"
              (select)="toggleNoiseSuppression()"
              [color]="isNoiseSuppressionOn ? 'danger' : null"
              data-tid="stream-controls/toggle-noise-suppression"
              [disabled]="isMicDisabled() || isMutedMic"
            >
              @if (!isNoiseSuppressionOn) {
              <span translate>Enable noise suppression</span>
              } @if (isNoiseSuppressionOn) {
              <span translate>Disable noise suppression</span>
              }
            </av-menu-item>
            }
            <av-menu-item type="separator"></av-menu-item>
            <av-menu-item
              [disabled]="isMicDisabled()"
              (select)="toggleMute(kindAudio)"
              (keyArrowDown)="muteMicArrowDown()"
              [color]="!isMutedMic ? 'danger' : null"
              data-tid="stream-controls/toggle-mic-mute-menu"
              #muteMicRef
            >
              @if (!isMutedMic) {
              <span
                >{{ "Mute mic" | translate }} <span class="keyboard">a</span>
              </span>
              } @if (isMutedMic) {
              <span
                >{{ "Unmute mic" | translate }}
                <span class="keyboard">a</span></span
              >
              }
            </av-menu-item>
          </av-menu>
        </av-card-body>
      </av-card>
    </div>
    }

    <!-- [class.control-has-menu]="!isMobile && !isOnHold" [class.control-has-menu-active]="isMutedCam" -->
    @if (isVideoDeviceAvailable) {
    <div class="control" [class.control-disabled]="isCamDisabled()">
      <button
        [attr.aria-label]="
          (isMutedCam ? 'Turn on camera' : 'Turn off camera') | translate
        "
        avButton
        #btnCamRef
        ofType="icon"
        [color]="isMutedCam ? 'basic' : 'primary'"
        [size]="size"
        [raised]="true"
        class="room-control-min-size"
        id="btn-mute-cam"
        (click)="toggleMute(kindVideo)"
        (keydown)="focus($event, kindVideo)"
        [attr.data-tid]="
          isMutedCam ? 'stream-controls/cam-unmute' : 'stream-controls/cam-mute'
        "
      >
        @if (!isMutedCam) {
        <av-icon name="cam"></av-icon>
        } @if (isMutedCam) {
        <av-icon name="cam-mute" mode="dark"></av-icon>
        }
      </button>
      <!-- <button
        *ngIf="isControlOptionsToggleFocus() === kindVideo"
        class="control-options-toggle"
        avButton
        size="xxs"
        ofType="icon"
        color="primary"
        >
        <av-icon name="chevron-right" size="sm"></av-icon>
      </button> -->
      @if (isVideoDeviceMissing || isVideoDevicePermissionMissing) {
      <av-tooltip
        class="control-error-tooltip"
        [message]="
          isVideoDeviceMissing ? 'No devices available' : 'Permission required'
        "
      >
        <div class="control-error">!</div>
      </av-tooltip>
      } @if (!isMobile && !isCamDisabled()) {
      <av-card
        [class.hidden]="isOnHold()"
        arrow="bottom"
        type="control-options"
        class="control-options-on-hover"
        [menu]="true"
        vAlign="top"
        hAlign="center"
        [backdrop]="true"
        [popup]="true"
      >
        <av-card-body size="xs" type="container">
          <av-menu>
            <av-menu-item icon="cam" [arrow]="true" [disabled]="isMutedCam">
              {{ activeVideoDevice.label }}
              <av-card sub-menu [backdrop]="false">
                <av-card-body size="xs">
                  <av-menu>
                    @for (device of videoDevices; track device.deviceId) {
                    <av-menu-item
                      type="radio"
                      (select)="changeDevice(device)"
                      [checked]="device.deviceId === activeVideoDevice.deviceId"
                      data-tid="stream-controls/change-video"
                    >
                      {{ device.label }}
                    </av-menu-item>
                    }
                  </av-menu>
                </av-card-body>
              </av-card>
            </av-menu-item>
            @if (isFilterAvailable) {
            <av-menu-item type="separator"></av-menu-item>
            <!-- [color]="isFilterOn?'danger': null" -->
            <av-menu-item
              icon="background-effect"
              #effectsMenuItemRef
              [arrow]="true"
              [disabled]="!isFilterEnabled"
              (keyArrowRight)="navigateToEffects()"
            >
              <!-- *ngIf="!isFilterOn" -->
              <span translate>Background effects</span>
              <!-- <span *ngIf="isFilterOn" translate>No Effect</span> -->
              <av-card
                class="sub-menu-effects"
                sub-menu
                [menu]="true"
                [backdrop]="false"
              >
                <av-card-body size="xs">
                  <app-background-effects
                    (keyArrowLeft)="navigateOutOfEffects()"
                    #effectsRef
                  ></app-background-effects>
                </av-card-body>
              </av-card>
            </av-menu-item>
            } @if (isPortraitModeAvailable) {
            <av-menu-item type="separator"></av-menu-item>
            <av-menu-item
              [icon]="isPortraitMode ? 'landscape-mode' : 'portrait-mode'"
              (select)="togglePortraitMode()"
              [disabled]="isPortraitModeDisabled"
              data-tid="stream-controls/toggle-portrait-mode"
            >
              @if (!isPortraitMode) {
              <span translate>Portrait mode</span>
              } @if (isPortraitMode) {
              <span translate>Default mode</span>
              }
            </av-menu-item>
            }
            <av-menu-item type="separator"></av-menu-item>
            <av-menu-item
              [disabled]="isCamDisabled()"
              (select)="toggleMute(kindVideo)"
              [color]="!isMutedCam ? 'danger' : null"
              (keyArrowDown)="muteCamArrowDown()"
              data-tid="stream-controls/toggle-video-mute-menu"
              #muteCamRef
            >
              @if (!isMutedCam) {
              <span>
                {{ "Turn camera off" | translate }}
                <span class="keyboard">v</span>
              </span>
              } @if (isMutedCam) {
              <span>
                {{ "Turn camera on" | translate }}
                <span class="keyboard">v</span>
              </span>
              }
            </av-menu-item>
          </av-menu>
        </av-card-body>
      </av-card>
      }
    </div>
    } @if (isRingLightAvailable && !isMobileSize()) {
    <div class="control">
      <av-tooltip message="Ring light" [enabled]="!isMobile">
        <button
          [attr.aria-label]="'Ring light' | translate"
          avButton
          ofType="icon"
          [color]="isRingLightOn() ? 'basic' : 'primary'"
          [disabled]="isOnHold()"
          [size]="size"
          [raised]="true"
          (click)="isRingLightOn.set(!isRingLightOn())"
          class="room-control-min-size"
          data-tid="stream-controls/ring-light"
        >
          <av-icon
            name="ring-light"
            [mode]="isRingLightOn() ? 'dark' : undefined"
          ></av-icon>
        </button>
      </av-tooltip>
      @if (!isMobile && isRingLightOn()) {
      <av-card
        [class.hidden]="isOnHold()"
        arrow="bottom"
        type="control-options"
        class="control-options-on-hover ring-light-options"
        [menu]="true"
        vAlign="top"
        hAlign="center"
        [backdrop]="true"
        [popup]="true"
      >
        <av-card-body size="xs" type="container">
          <div class="ring-light-slider-group">
            <label translate>Intensity</label>
            <input
              type="range"
              min="10"
              max="100"
              step="5"
              [ngModel]="ringLightIntensity()"
              (ngModelChange)="ringLightIntensity.set($event)"
            />
          </div>
          <div class="ring-light-slider-group">
            <label translate>Warmth</label>
            <input
              type="range"
              min="0"
              max="100"
              step="5"
              [ngModel]="ringLightWarmth()"
              (ngModelChange)="ringLightWarmth.set($event)"
            />
          </div>
        </av-card-body>
      </av-card>
      }
    </div>
    } @if (isSwitchCamAvailable) {
    <div class="control">
      <button
        arial-label="Switch camera"
        avButton
        ofType="icon"
        color="primary"
        [size]="size"
        [raised]="true"
        id="btn-switch-camera"
        [disabled]="isSwitchCamDisabled()"
        class="btn-switch-cam room-control-min-size"
        (click)="switchCam()"
        data-tid="stream-controls/switch-camera"
      >
        <av-icon name="camera-reverse"></av-icon>
      </button>
    </div>
    }

    <!-- <div class="control control-cc" [class.hidden]="!isCaptionVisible" *ngIf="isCaptionAvailable && localStream">
  <app-captions-control [size]="size" [disabled]="isOnHold" [conferenceId]="conferenceId"
    [applicationId]="applicationId" [stream]="localStream">
  </app-captions-control>
</div> -->

    @if (isHoldEnabled && !isMobileSize()) {
    <div class="control">
      <av-tooltip [enabled]="!isMobile">
        <button
          [attr.aria-label]="'Put call on hold' | translate"
          avButton
          ofType="icon"
          [color]="isOnHold() && isHoldLocal() ? 'basic' : 'primary'"
          [size]="size"
          [raised]="true"
          id="btn-hold"
          [disabled]="isHoldDisabled()"
          (click)="toggleHold()"
          class="room-control-min-size"
          [attr.data-tid]="
            isOnHold() ? 'stream-controls/hold-off' : 'stream-controls/hold-on'
          "
        >
          @if (!isOnHold() || (isOnHold() && !isHoldLocal())) {
          <av-icon name="pause"></av-icon>
          } @if (isOnHold() && isHoldLocal()) {
          <av-icon name="pause" mode="dark"></av-icon>
          }
        </button>
        <ng-container tooltipMessage>
          <ng-container>
            {{ "Hold call" | translate }}
            <span class="keyboard keyboard-tooltip">h</span>
          </ng-container>
          <!-- <ng-container *ngIf="!isOnHold() || (isOnHold() && !isHoldLocal())">
        {{ "Hold call" | translate }}
        <span class="keyboard keyboard-tooltip">h</span>
      </ng-container>
      <ng-container *ngIf="isOnHold() && isHoldLocal()">
        {{ "Hold call" | translate }}
        <span class="keyboard keyboard-tooltip">h</span>
      </ng-container> -->
        </ng-container>
      </av-tooltip>
    </div>
    } @if (isDisplayCaptureAvailable && !isMobileSize()) {
    <div class="control control-device-capture">
      <app-display-capture
        [screenStream]="screenStream"
        [size]="size"
      ></app-display-capture>
    </div>
    } @if (isCobrowseTerminateAvailable()) {
    <div class="control">
      <av-tooltip message="Stop co-browsing">
        <button
          avButton
          ofType="icon"
          [attr.aria-label]="'Stop co-browsing' | translate"
          data-tid="stream-controls/stop-cobrowse"
          color="basic"
          [size]="size"
          [raised]="true"
          id="btn-stop-cobrowse"
          class="room-control-min-size"
          (click)="terminateCobrowse()"
        >
          <av-icon name="cobrowse" size="md"></av-icon>
        </button>
      </av-tooltip>
    </div>
    }

    <!-- <div class="control">
<av-tooltip message="AI Assistant">
  <button
    [attr.aria-label]="'Open Assistant' | translate"
    avButton
    color="primary"
    ofType="icon"
    [size]="size"
    [raised]="true"
    id="btn-ai-assistant"
    (click)="toggleAssistant()"
    data-tid="stream-controls/ai-assistant"
    >
    <av-icon name="transcript" size="sm"></av-icon>
  </button>
</av-tooltip>
</div> -->

    @if (isNudgeAvailable) {
    <div class="control" [class.control-disabled]="isNudgeDisabled()">
      <av-tooltip message="Nudge">
        <button
          avButton
          ofType="icon"
          [attr.aria-label]="'Nudge' | translate"
          data-tid="stream-controls/nudge"
          color="primary"
          [size]="size"
          [disabled]="isNudgeDisabled()"
          [raised]="true"
          class="room-control-min-size"
          (click)="nudge()"
        >
          <av-icon
            name="hand-wave"
            [class.wave]="isNudging()"
            size="md"
          ></av-icon>
        </button>
      </av-tooltip>
    </div>
    } @if (isFileTransferAvailable() && !isMobileSize()) {
    <div class="control">
      <av-tooltip message="Send a file">
        <button
          [attr.aria-label]="'Send a file' | translate"
          avButton
          color="primary"
          ofType="icon"
          [size]="size"
          [raised]="true"
          id="btn-send-file"
          [disabled]="isFileTransferDisabled()"
          (click)="selectFile()"
          class="room-control-min-size"
          data-tid="stream-controls/file-transfer"
        >
          <av-icon name="upload" size="sm"></av-icon>
          <input
            style="display: none"
            #fileInput
            [accept]="allowedFileTypes()"
            name="file-transfer"
            type="file"
            (change)="fileAdded($event)"
          />
        </button>
        <!-- <av-card
      type="control-options"
      arrow="bottom"
      [popup]="true"
      [class.popup-visible]="true"
      vAlign="top"
      hAlign="center"
      [menu]="true"
      >
      <av-card-body size="xs" type="container">
        <av-menu>
          <av-menu-item>
            <span translate>Participant</span>
          </av-menu-item>
        </av-menu>
      </av-card-body>
    </av-card> -->
      </av-tooltip>
    </div>
    } @if (isTagAvailable() && !isMobileSize()) {
    <div class="control">
      <av-tooltip message="Tag interaction">
        <button
          [attr.aria-label]="'Tag interaction' | translate"
          avButton
          [color]="isTagOpen() ? 'basic' : 'primary'"
          ofType="icon"
          [size]="size"
          [raised]="true"
          id="btn-tag-interaction"
          (click)="toggleTags()"
          #tagsBtnRef
          class="room-control-min-size"
          data-tid="stream-controls/tag-interaction"
        >
          <av-icon name="tag" size="sm"></av-icon>
        </button>
      </av-tooltip>
      @if (isTagOpen()) {
      <app-conversation-tags
        [@slideInOut]="true"
        #tagsRef
        [activeTags]="tags()"
        (dismiss)="toggleTags()"
        (changed)="tagsChanged($event)"
      ></app-conversation-tags>
      }
    </div>
    } @if (isMoreActionsEnabled()) {
    <div class="control">
      <av-tooltip message="More actions" [enabled]="!isMobile">
        <button
          [attr.aria-label]="'More actions' | translate"
          avButton
          [color]="isMoreActionsOpen() ? 'basic' : 'primary'"
          ofType="icon"
          [size]="size"
          [raised]="true"
          id="btn-more-actions"
          (click)="toggleMoreActions()"
          #moreActionsBtnRef
          class="room-control-min-size"
          data-tid="stream-controls/more-actions"
        >
          <av-icon name="more-vertical" size="sm"></av-icon>
        </button>
      </av-tooltip>
      @if (isMoreActionsOpen()) {
      <av-card
        id="more-actions-menu"
        arrow="bottom"
        [backdrop]="true"
        [menu]="true"
        vAlign="top"
        [popup]="true"
        hAlign="center"
        [@slideInOut]="true"
        #moreActionsRef
        class="control-options-visible"
        type="control-options"
      >
        <av-card-body size="xs" type="container">
          <av-menu>
            @if (isHoldEnabled) {
            <av-menu-item
              icon="pause"
              [arrow]="false"
              [color]="isOnHold() && isHoldLocal() ? 'danger' : undefined"
              [disabled]="isHoldDisabled()"
              (select)="isMoreActionsOpen.set(false); toggleHold()"
              [attr.data-tid]="
                isOnHold()
                  ? 'stream-controls/hold-off'
                  : 'stream-controls/hold-on'
              "
            >
              {{ (isOnHold() && isHoldLocal() ? "Resume call" : "Hold call") | translate }}
            </av-menu-item>
            } @if (isRingLightAvailable && !isInPip()) {
            <av-menu-item
              icon="ring-light"
              [arrow]="false"
              [disabled]="isOnHold()"
              (select)="
                isMoreActionsOpen.set(false);
                isRingLightOn.set(!isRingLightOn())
              "
              data-tid="stream-controls/ring-light"
            >
              {{ "Ring light" | translate }}
            </av-menu-item>
            } @if (isDisplayCaptureAvailable) {
            <app-display-capture
              [screenStream]="screenStream"
              type="menu-item"
              (click)="isMoreActionsOpen.set(false)"
            ></app-display-capture>
            } @if (isFileTransferAvailable()) {
            <av-menu-item
              icon="upload"
              (select)="this.isMoreActionsOpen.set(false); selectFile()"
              [disabled]="isFileTransferDisabled()"
            >
              {{ "Send a file" | translate }}
              <input
                style="display: none"
                #fileInput
                [accept]="allowedFileTypes()"
                name="file-transfer"
                type="file"
                (change)="fileAdded($event)"
              />
            </av-menu-item>
            } @if (isTagAvailable()) {
            <av-menu-item icon="tag" (select)="toggleTags()" [arrow]="false">
              {{ "Tag interaction" | translate }}
            </av-menu-item>
            }
          </av-menu>
        </av-card-body>
      </av-card>
      } @if (isTagOpen()) {
      <app-conversation-tags
        [@slideInOut]="true"
        #tagsRef
        [activeTags]="tags()"
        (dismiss)="toggleTags()"
        (changed)="tagsChanged($event)"
      ></app-conversation-tags>
      }
    </div>
    } @if (isPipAvailable) {
    <!-- av-icon and av-tooltip do not react to input changes, render one per state -->
    <div class="control">
      @if (isInPip()) {
      <av-tooltip message="Back to tab" [enabled]="!isMobile">
        <button
          [attr.aria-label]="'Back to tab' | translate"
          avButton
          color="primary"
          ofType="icon"
          [size]="size"
          [raised]="true"
          class="room-control-min-size"
          (click)="togglePip()"
          data-tid="stream-controls/pip-off"
        >
          <av-icon name="pip-in" size="sm"></av-icon>
        </button>
      </av-tooltip>
      } @else {
      <av-tooltip message="Picture-in-picture" [enabled]="!isMobile">
        <button
          [attr.aria-label]="'Picture-in-picture' | translate"
          avButton
          color="primary"
          ofType="icon"
          [size]="size"
          [raised]="true"
          class="room-control-min-size"
          (click)="togglePip()"
          data-tid="stream-controls/pip-on"
        >
          <av-icon name="pip-out" size="sm"></av-icon>
        </button>
      </av-tooltip>
      }
    </div>
    }
  </div>

  @if (isLeaveAvailable) {
  <av-tooltip
    class="control control-leave"
    [class.control-leave-space]="isCenterControlVisible"
    [enabled]="!user.isAgent"
    message="Leave call"
  >
    <button
      #leave
      class="button-leave room-control-min-size"
      [attr.aria-label]="'Leave call' | translate"
      avButton
      color="danger"
      ofType="icon"
      [size]="size"
      [raised]="true"
      id="btn-leave-call"
      [disabled]="isOnHold()"
      (click)="leaveConference()"
      (keyup)="leaveKeyUp($event)"
      data-tid="stream-controls/leave-call"
    >
      <av-icon name="phone-down"></av-icon>
    </button>
    @if (user.isAgent && !isOnHold()) {
    <av-card
      type="control-options"
      class="control-options-on-hover"
      [arrow]="isLeavePopupEndAligned() ? 'bottom-right' : 'bottom'"
      [popup]="true"
      [class.popup-visible]="isLeavePopupOpen()"
      vAlign="top"
      [hAlign]="isLeavePopupEndAligned() ? 'right' : 'center'"
      [menu]="true"
    >
      <av-card-body size="xs" type="container">
        @if (!hasMultipleAgents()) {
        <av-menu>
          @if (canTerminate) {
          <av-menu-item
            icon="turn-off"
            (select)="terminateConference()"
            data-tid="stream-controls/end-call"
          >
            <span translate>End call</span>
          </av-menu-item>
          } @if (!canTerminate) {
          <av-menu-item
            icon="exit"
            (select)="exitConference()"
            data-tid="stream-controls/leave-call-menu"
          >
            <span translate>Leave call</span>
          </av-menu-item>
          }
        </av-menu>
        } @if (hasMultipleAgents()) {
        <av-menu>
          @if (!isGuestAgent) {
          <av-menu-item
            icon="turn-off"
            (select)="terminateConference()"
            data-tid="stream-controls/end-for-all"
          >
            <span translate>End call for all</span>
          </av-menu-item>
          <av-menu-item type="separator"></av-menu-item>
          }
          <av-menu-item
            icon="exit"
            (select)="exitConference()"
            data-tid="stream-controls/leave-call-multiple-agents"
          >
            <span translate>Leave call</span>
          </av-menu-item>
        </av-menu>
        }
      </av-card-body>
    </av-card>
    }
  </av-tooltip>
  }
</div>
